import React, { useRef, useLayoutEffect } from 'react';
import supportsTime from 'time-input-polyfill/supportsTime';
import TimePolyfill from 'time-input-polyfill';

type Props = {
  value: string;
  className?: string;
  title?: string;
  style?: {};
  required?: boolean;
  onChange: Function;
};

export default function TimeInput({ onChange, value: currentValue, title = 'time', className, ...props }: Props) {
  const inputRef = useRef(null);
  useLayoutEffect(() => {
    // eslint-disable-next-line no-new
    if (!supportsTime) new TimePolyfill(inputRef.current);
  }, []);

  return (
    <input
      type="time"
      title={title}
      ref={inputRef}
      value={currentValue}
      className={`time-input ${className}`}
      onChange={e => onChange(e.currentTarget.value)}
      onKeyDown={!supportsTime ? e => onChange(e.currentTarget.dataset?.value) : null}
      {...props}
    />
  );
}
